import Vue from "vue";
import Router from "vue-router";
import store from "./../store/index";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "*",
      redirect: "Agreement"
    },
    {
      path: "/Agreement",
      name: "Agreement",
      meta: {
        title: "预约须知"
      },
      component: () =>
        import(/* webpackChunkName: "allrouter" */ "@/pages/Agreement.vue")
    },
    {
      path: "/Catalogue",
      name: "Catalogue",
      meta: {
        title: "预约业务选择"
      },
      component: () =>
        import(/* webpackChunkName: "allrouter" */ "@/pages/Catalogue.vue")
    },
    {
      path: "/MyOrder",
      name: "MyOrder",
      meta: {
        title: "我的预约"
      },
      component: () =>
        import(/* webpackChunkName: "allrouter" */ "@/pages/MyOrder.vue")
    },
    {
      path: "/FormReg",
      name: "FormReg",
      components: {
        default: () => import("@/pages/FormReg")
      }
    }
  ]
});

// 全局路由守卫（验证用户名密码是否合法，合法时显示当前页面，否则返回登录界面，并给出提示信息）
router.beforeEach(function(to, form, next) {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  // 如果用户信息已经加载并且不为空则说明该用户已登录，可以继续访问路由，否则跳转到首页
  if (store.state.userLoadStatus === true || to.path === "/Agreement") {
    next();
  } else {
    if (store.state.userName !== "" && store.state.idcard !== "") {
      alert("非法请求！");
    }
    if(form.path != "/Agreement"){
      next("/Agreement");
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js